import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import tabLogo from './Assets/logo.png';

const ensureFavicon = () => {
  const existing = document.querySelector('link[rel~="icon"]');
  const linkEl = existing || document.createElement('link');

  linkEl.rel = 'icon';
  linkEl.href = tabLogo;

  if (!existing) {
    document.head.appendChild(linkEl);
  }
};

ensureFavicon();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
